import { render, staticRenderFns } from "./user-records-view.vue?vue&type=template&id=785af0fb&"
import script from "./user-records-view.vue?vue&type=script&lang=js&"
export * from "./user-records-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports